export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '3.6.13',
};
//# sourceMappingURL=buildEnv.js.map